<template>
  <div class="container petition-list mt-5">
    <h4 class="bold">{{ $t('action.newestPetitions', locale) }}</h4>
    <div class="justify-content-center mb-0">
      <div class="actions d-md-flex flex-wrap justify-content-between">
        <div
          v-for="(petition, i) in petitions_list"
          :key="i"
          class="p-card d-flex flex-column justify-content-between mb-3 text-center petition"
        >
          <img class="mb-1" :src="petition.thumbnail" :alt="petition.title" />
          <p class="bold px-2">{{ petition.title }}</p>
          <div class="p-card__info px-2 pb-2">
            <a :href="petition.canonical_url">
              <button class="btn btn-xsm btn-sign mb-1 bold">
                {{ $t('action.signNow', locale) }}
              </button>
            </a>
            <div class="p-card__meta">
              <span>
                <SignatureIconSVG />
                <span>
                  {{ petition.signature_count }}
                  {{ $tc('action.signaturesPlural', petition.signature_count, locale) }}
                </span>
              </span>
              <span>
                <ClockIconSVG />
                <span>
                  {{ $tc('action.monthsAgoPlural', displayDate(petition.created), locale, { date: displayDate(petition.created)}) }}
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <span v-if="moreResults == true" id="list-end"></span>
      <v-btn
        color="#da2a4c"
        tile
        depressed
        outlined
        class="text-uppercase row mr-auto ml-auto load-more"
        @click="getNextPage"
      >
        {{ $t('action.loadMorePetitions', locale) }}
      </v-btn>
      <AllOutSpinner v-if="loading == true" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AllOutSpinner from './AllOutSpinner.vue'
import SignatureIconSVG from './assets/images/symbols/signatures.svg?inline'
import ClockIconSVG from './assets/images/symbols/clock.svg?inline'

export default {
  name: 'PetitionList',
  components: { AllOutSpinner, SignatureIconSVG, ClockIconSVG },
  props: {
    endpoint: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      locale: document.documentElement.lang || 'en',
      page: 0,
      petitions_list: [],
      loading: false,
      moreResults: true
    }
  },
  computed: {
    ...mapState('actionForm', ['petitions'])
  },
  mounted() {
    this.getNextPage()
  },
  methods: {
    async getPage() {
      this.$store.commit('actionForm/SET_PETITION_ENDPOINT', this.endpoint)
      this.$store.commit('actionForm/SET_PETITION_PAGE', this.page)
      await this.$store.dispatch('actionForm/fetchPetitionData')
      this.petitions_list.push(...this.petitions.results)
      this.loading = false
      if (this.petitions.next) {
        this.$nextTick(() => {
          this.infiniteScroll()
        })
      } else {
        this.moreResults = false
      }
    },
    getNextPage() {
      this.page++
      this.getPage()
    },
    displayDate(rawDateString) {
      const startDate = new Date(rawDateString)
      const endDate = new Date()
      const months =
        endDate.getMonth() -
        startDate.getMonth() +
        12 * (endDate.getFullYear() - startDate.getFullYear())
      return months
    },
    infiniteScroll() {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.loading = true
            this.getNextPage()
            observer.unobserve(observerHtmlElement)
          }
        })
      })
      const observerHtmlElement = document.getElementById('list-end')
      observer.observe(observerHtmlElement)
    }
  }
}
</script>

<style lang="scss" scoped>
.petition {
  box-shadow: 0 1px 16px 0 rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  min-height: 310px;
  min-width: 200px;

  img {
    max-width: 100%;
  }

  .p-card__meta {
    font-size: 10px;
    color: #7c7c7c;
    display: flex;
    justify-content: space-around;
    span {
      display: flex;
      align-items: center;
      svg {
        margin-right: 0.2rem;
      }
      span {
        padding-top: 0.3rem;
      }
    }

    @media (max-width: 980px) {
      display: none !important;
    }
  }
}
.petition-list {
  max-width: 1185px;
  h4 {
    font-size: 18px;
    margin: 1.3125rem;
    @media (max-width: 768px) {
      text-align: center;
    }
  }

  .btn-sign {
    min-width: 100%;
    font-size: 20px;
    border-radius: 0;
    padding: 0.1rem;
    font-weight: 800;
  }

  .load-more {
    @media (min-width: 980px) {
      display: none;
    }
  }
  .actions {
    column-gap: 1.3125rem;
    row-gap: 2rem;
  }
  @media (max-width: 768px) {
    max-width: 286px;
    .load-more {
      margin-top: 0.5rem;
    }
  }
}
#list-end {
  @media (max-width: 980px) {
    display: none !important;
  }
}
</style>
